import Cookies from 'js-cookie';
import {getParameterByName, GetCookieDomain} from '../utils/tools.js';
import {getPlatform} from '../lib/platform';
import {getProjectInfo as getAppProjectInfo} from '../lib/app/api';

const ACCOUNT_INFO_GET = 'scratch-gui/account-info/ACCOUNT_INFO_GET';
const ACCOUNT_INFO_LOGOUT = 'scratch-gui/account-info/ACCOUNT_INFO_LOGOUT';

const ACCOUNT_NICKNAME = 'nickname';
const ACCOUNT_AVATAR = 'avatar';
const ACCOUNT_UID = 'userId';
const ACCOUNT_IS_LOGIN = 'isLogin';
const ACCOUNT_LOGIN_URL = 'loginUrl';

const originState = {
    [ACCOUNT_IS_LOGIN]: false,
    [ACCOUNT_UID]: null,
    [ACCOUNT_NICKNAME]: '',
    [ACCOUNT_AVATAR]: '',
    [ACCOUNT_LOGIN_URL]: `https://api.hetao101.com/logic/v1/wechat/pc/login?redirect=${window.location.href}`
};

if (getPlatform() === 'APP') {
    const data = getAppProjectInfo();
    let options;
    if (window.location.hostname.includes('hetao101')) {
        options = {domain: '.hetao101.com', path: '/'};
    } else {
        options = {path: '/'};
    }
    Cookies.set('userId', data.user_id, options);
    Cookies.set('token', data.user_token, options);

}
const initialState = {
    [ACCOUNT_IS_LOGIN]: !!getParameterByName('teacherId') || !!Cookies.get('userId'),
    [ACCOUNT_UID]: Number(getParameterByName('teacherId')) || Number(Cookies.get('userId')) || 0,
    [ACCOUNT_NICKNAME]: Cookies.get('nickname') || '',
    [ACCOUNT_AVATAR]: Cookies.get('avatar') || '',
    [ACCOUNT_LOGIN_URL]: `https://api.hetao101.com/logic/v1/wechat/pc/login?redirect=${window.location.href}`
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case ACCOUNT_INFO_GET:
        return state;

    case ACCOUNT_INFO_LOGOUT:
        Cookies.remove('userId', {path: '/', domain: GetCookieDomain() || 'hetao101.com'});
        return Object.assign({}, originState);
        
    default:
        return state;
    }
};
const logout = function () {
    return {
        type: ACCOUNT_INFO_LOGOUT
    };
};
const getAccountInfo = state => state.scratchGui.accountInfo;

export {
    reducer as default,
    initialState as accountInfoInitialState,
    getAccountInfo,
    logout
    
};
